import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookie from 'universal-cookie';
import { getCurrentWhatsNew } from './whatsNewApi';

const startedKeys = new Set();

const blockedPath = (pathname) =>
  pathname === '/' ||
  pathname.startsWith('/login') ||
  pathname.startsWith('/mdLogin') ||
  pathname.startsWith('/demo') ||
  pathname.startsWith('/shared-');

/**
 * After login / workspace load, ask whether What's New should open.
 * The display counter is incremented only when the feed actually renders.
 */
const WhatsNewAutoOpen = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (blockedPath(location.pathname)) return undefined;

    const cookie = new Cookie();
    const userToken = cookie.get('user');
    const entityId = cookie.get('entityId');
    const workspace = sessionStorage.getItem('selectedApplication');
    if (!userToken || !entityId || !workspace) return undefined;

    const sessionKey = `whatsNew.auto.${workspace}.${String(userToken).slice(-16)}`;
    if (sessionStorage.getItem(sessionKey) === 'done' || startedKeys.has(sessionKey)) {
      return undefined;
    }
    startedKeys.add(sessionKey);

    getCurrentWhatsNew()
      .then((current) => {
        sessionStorage.setItem(sessionKey, 'done');
        if (!current?.showAutomatically || !current?.page?.id) return;
        const alreadyAuto =
          location.pathname.startsWith('/whatsNew/feed') &&
          new URLSearchParams(location.search).get('auto') === '1';
        if (alreadyAuto) return;
        navigate(`/whatsNew/feed?pageId=${current.page.id}&auto=1`, { replace: true });
      })
      .catch(() => {
        startedKeys.delete(sessionKey);
      });

    return undefined;
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default WhatsNewAutoOpen;
